import { render, staticRenderFns } from "./CompanyManage.vue?vue&type=template&id=1482bc6a&scoped=true"
import script from "./CompanyManage.vue?vue&type=script&lang=js"
export * from "./CompanyManage.vue?vue&type=script&lang=js"
import style0 from "./CompanyManage.vue?vue&type=style&index=0&id=1482bc6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482bc6a",
  null
  
)

export default component.exports